"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PageMedia = _interopRequireDefault(require("../PageMedia/PageMedia"));
var _ArticleTop = _interopRequireDefault(require("./ArticleTop/ArticleTop"));
var _GoBackButton = _interopRequireDefault(require("../GoBackButton/GoBackButton"));
var _ArticleBoxArea = _interopRequireDefault(require("../ArticleBoxArea/ArticleBoxArea"));
var _SIACMSContent = _interopRequireDefault(require("../SIACMSContent/SIACMSContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-article {\n  display: flex;\n  flex-direction: column;\n  max-width: 66rem;\n  margin: auto;\n  align-items: center; }\n  .sia-article .container {\n    width: 100%;\n    max-width: 698px; }\n  .sia-article .article_boxes_area_section-container {\n    display: flex;\n    align-self: flex-start;\n    padding-inline: 0px; }\n\n@media (max-width: 42rem) {\n  .sia-article .container {\n    max-width: 100%;\n    padding-inline: 16px; } }\n\n@media (max-width: 66rem) {\n  .sia-article .container {\n    max-width: 508px;\n    padding-inline: 16px; }\n  .sia-article .article_boxes_area_section-container {\n    padding-inline: 16px; } }\n";
  const fileName = "SIAArticle_SIAArticle";
  const element = document.querySelector("style[data-sass-component='SIAArticle_SIAArticle']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAArticle = _ref => {
  let {
    item,
    history,
    lang,
    translate,
    showModal = false
  } = _ref;
  const media = item?.pictures_gallery?.map(_ref2 => {
    let [picture] = _ref2;
    if (picture.teaser_image) {
      return {
        imagePlaceholder: picture?.teaser_image[0].desktop?.url,
        imagePlaceholderTablet: picture?.teaser_image[0].tablet?.url,
        imagePlaceholderMobile: picture?.teaser_image[0].mobile?.url,
        src: picture?.url,
        type: 'VIDEO',
        copyright: {
          copyright: picture.copyright,
          title: picture.title
        }
      };
    }
    return {
      src: picture?.desktop?.url,
      srcTablet: picture?.tablet?.url,
      srcMobile: picture?.mobile?.url,
      type: 'IMAGE',
      copyright: {
        copyright: picture.copyright,
        title: picture.title
      }
    };
  });
  const themen_articles = item.themen_articles;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-article "
  }, /*#__PURE__*/_react.default.createElement(_GoBackButton.default, {
    history: history,
    lang: lang
  }), media?.length > 0 && /*#__PURE__*/_react.default.createElement(_PageMedia.default, {
    items: media,
    showModal: showModal
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_ArticleTop.default, {
    article: item
  }), item.page_bottom && /*#__PURE__*/_react.default.createElement(_SIACMSContent.default, {
    lang: lang,
    items: item.page_bottom,
    history: history,
    translate: translate
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "article_boxes_area_section-container sia-padding-05-top"
  }, themen_articles && /*#__PURE__*/_react.default.createElement(_ArticleBoxArea.default, {
    lang: lang,
    items: themen_articles,
    history: history,
    translate: translate
  })));
};
SIAArticle.propTypes = {
  item: _propTypes.default.object.isRequired
};
var _default = exports.default = SIAArticle;